
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2428_16044)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"var(--theme-color-white-text)"}},[_c('path',{attrs:{"d":"M13.05 6.128c-.05.216-.133.426-.245.621l-4.487 7.772.276.479a1.659 1.659 0 002.266.607l4.31-2.488a1.659 1.659 0 00.607-2.266L13.05 6.128zM12.114 4.979c.098.413.035.848-.177 1.215l-4.531 7.848a1.659 1.659 0 01-2.266.607L.83 12.161a1.659 1.659 0 01-.607-2.266l4.53-7.848c.213-.368.558-.64.965-.76L9.186.255a1.659 1.659 0 012.086 1.204l.841 3.519zm-2.19-1.934a.83.83 0 11-1.437-.83.83.83 0 011.437.83z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2428_16044"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    